import React, {useEffect, useState} from "react";
import "../../css/news.css";
import "../../css/newsCard.css"
import {Link} from "react-router-dom";
import {IconImg, IconVideo} from "../utils/Icons";
import { EyeOutlined } from '@ant-design/icons';
import {useTheme} from "../header/Header"

export function NewsPreviewCard({news}) {

    const { theme } = useTheme();

    return (

        <div className={`overlay`}>
            <Link to={news.url} className={`news-item ${theme}`}>
                <h3 className="mobile-only-title">{news.title}</h3>
                <img
                    src={news.image}
                    alt="Фото"
                    className="news-preview-image"
                />
                <div className="news-preview">
                    <div>
                        <h3 className={`desktop-title ${theme}`}>{news.title}</h3>
                        <p className={`${theme === "light"? "news-light-p" : "news-dark-p"}`}>{news.previewText}</p>
                        <div className="news-preview-container">
                            <i className={`news-date ${theme}`}>{news.date}</i>
                            <div className="news-views">
                                <span className={`views-count ${theme}`}>{news.views || 0}</span>
                                <EyeOutlined className="eye-icon" />
                            </div>
                        </div>
                    </div>
                </div>
            </Link>
        </div>
    );
}

export function NewsPhoto({images}) {

    const [mainImage, setMainImage] = useState(images[0]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [thumbnailIndex, setThumbnailIndex] = useState(0); // Индекс начала видимых миниатюр
    const thumbnailsPerPage = 6; // Количество миниатюр на одной "странице"
    const { theme } = useTheme();

    const handleThumbnailClick = (image, index) => {
        setMainImage(image);
        setCurrentIndex(index);
    };

    const handleMainImageClick = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const handleNextImage = () => {
        const nextIndex = (currentIndex + 1) % images.length;
        setMainImage(images[nextIndex]);
        setCurrentIndex(nextIndex);
    };

    const handlePrevImage = () => {
        const prevIndex = (currentIndex - 1 + images.length) % images.length;
        setMainImage(images[prevIndex]);
        setCurrentIndex(prevIndex);
    };

    const handleNextThumbnails = () => {
        if (thumbnailIndex + thumbnailsPerPage < images.length) {
            setThumbnailIndex(thumbnailIndex + thumbnailsPerPage);
        }
    };

    const handlePrevThumbnails = () => {
        if (thumbnailIndex - thumbnailsPerPage >= 0) {
            setThumbnailIndex(thumbnailIndex - thumbnailsPerPage);
        }
    };

    const visibleThumbnails = images.slice(
        thumbnailIndex,
        thumbnailIndex + thumbnailsPerPage
    );

    const isVideo = (file) => {
        return file.endsWith('.webm');
    };

    useEffect(()=>{
        setMainImage(images[0])
    }, [images])

    // Считывание нажатия ESC
    useEffect(() => {
        const handleEscKey = (event) => {
            if (event.key === "Escape") {
                setIsModalOpen(false);
            }
        };

        document.addEventListener('keydown', handleEscKey);
        return () => {
            document.removeEventListener('keydown', handleEscKey);
        };
    }, []);

    return (
        <div className="news-card-image">
            <div className={"news-card-image-wrapper"}>
                {isVideo(mainImage) ? (
                    <video
                        src={mainImage}
                        className="news-main-image"
                        controls
                        onClick={handleMainImageClick}
                    />
                ) : (
                    <img
                        src={mainImage}
                        alt="Основное изображение"
                        className="news-main-image"
                        onClick={handleMainImageClick}
                    />
                )}
                {/* Условие для отображения иконки */}
                {!isVideo(mainImage) && (
                    <div className="news-card-icon-container" onClick={handleMainImageClick}>
                        <IconImg />
                    </div>
                )}
            </div>
            <div className="news-thumbnails">
                {thumbnailIndex > 0 && (
                    <button className="news-prev-thumbnails" onClick={handlePrevThumbnails}>
                        &#10094;
                    </button>
                )}
                {visibleThumbnails.map((image, index) => (
                    isVideo(image) ? (
                        <div className="news-card-thumbnail-video-wrapper" key={thumbnailIndex + index}
                             onClick={() => handleThumbnailClick(image, thumbnailIndex + index)}>
                            <video
                                src={image}
                                className="news-card-thumbnail-video"
                            />
                            <IconVideo/>
                        </div>
                    ) : (
                        <img
                            key={thumbnailIndex + index}
                            src={image}
                            alt={`Миниатюра ${thumbnailIndex + index + 1}`}
                            onClick={() => handleThumbnailClick(image, thumbnailIndex + index)}
                        />
                    )
                ))}
                {thumbnailIndex + thumbnailsPerPage < images.length && (
                    <button className={`news-next-thumbnails ${theme}`} onClick={handleNextThumbnails}>
                        &#10095;
                    </button>
                )}
            </div>

            {isModalOpen && (
                <div className="modal">
                    <div className={`modal-content ${theme}`}>
                        <span className="close" onClick={handleCloseModal}>&times;</span>
                        {isVideo(mainImage) ? (
                            <video
                                src={mainImage}
                                className="modal-video"
                                controls
                            />
                        ) : (
                            <img
                                src={mainImage}
                                alt={`Изображение ${currentIndex + 1}`}
                                className="modal-image"
                            />
                        )}
                        <button className="prev" onClick={handlePrevImage}> &#10094;</button>
                        <button className="next" onClick={handleNextImage}>&#10095;</button>
                    </div>
                </div>
            )}
        </div>
    );
}
